import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFavorites } from "@/hooks/useFavorites";
import { cn } from "@/lib/utils";

interface Props {
  spotId: string;
  className?: string;
}

const FavoriteButton = ({ spotId, className }: Props) => {
  const { isFavorite, toggleFavorite } = useFavorites();
  const fav = isFavorite(spotId);
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      aria-label={fav ? "Remove from favorites" : "Add to favorites"}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleFavorite(spotId); }}
      className={cn("h-9 w-9", className)}
    >
      <Heart className={cn("h-5 w-5", fav ? "fill-red-500 text-red-500" : "text-muted-foreground")} />
    </Button>
  );
};

export default FavoriteButton;
